import { render, staticRenderFns } from "./MitraDC.vue?vue&type=template&id=36a676b0&"
import script from "./MitraDC.vue?vue&type=script&lang=js&"
export * from "./MitraDC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports